import { render } from "./RowForm.vue?vue&type=template&id=608754cc"
import script from "./RowForm.vue?vue&type=script&lang=js"
export * from "./RowForm.vue?vue&type=script&lang=js"

import "./RowForm.vue?vue&type=style&index=0&id=608754cc&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__